// LoginForm.jsx
// Modern form component with enhanced UX and professional design

import React, { useState } from 'react';
import { styles } from './styles';
import { EmailIcon, LockIcon } from '../../components/Icons';

const LoginForm = ({ 
  email, 
  setEmail, 
  password, 
  setPassword, 
  onSubmit, 
  loggingIn 
}) => {
  const [focusedField, setFocusedField] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  const getInputStyle = (fieldName) => ({
    ...styles.input,
    ...(focusedField === fieldName ? styles.inputFocused : {})
  });

  const buttonStyle = {
    ...styles.loginButton,
    ...(loggingIn ? styles.loginButtonDisabled : styles.loginButtonEnabled)
  };

  return (
    <form onSubmit={handleSubmit}>
      {/* Email Input Group */}
      <div style={styles.inputGroup}>
        <label style={styles.inputLabel} htmlFor="email">
          Email Address
        </label>
        <div style={styles.inputWrapper}>
          <EmailIcon 
            size={20} 
            color="#666" 
            style={styles.inputIcon}
          />
          <input
            id="email"
            type="email"
            placeholder="your.name@ilstu.edu"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onFocus={() => setFocusedField('email')}
            onBlur={() => setFocusedField(null)}
            style={getInputStyle('email')}
            className="login-input"
            required
            autoComplete="email"
          />
        </div>
      </div>
      
      {/* Password Input Group */}
      <div style={styles.inputGroup}>
        <label style={styles.inputLabel} htmlFor="password">
          Password
        </label>
        <div style={styles.inputWrapper}>
          <LockIcon 
            size={20} 
            color="#666" 
            style={styles.inputIcon}
          />
          <input
            id="password"
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onFocus={() => setFocusedField('password')}
            onBlur={() => setFocusedField(null)}
            style={getInputStyle('password')}
            className="login-input"
            required
            autoComplete="current-password"
          />
        </div>
      </div>
      
      {/* Submit Button with Loading State */}
      <button 
        type="submit"
        disabled={loggingIn}
        style={buttonStyle}
        className="login-button"
        onMouseEnter={(e) => {
          if (!loggingIn) {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 8px 24px rgba(206, 17, 38, 0.5)';
          }
        }}
        onMouseLeave={(e) => {
          if (!loggingIn) {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 16px rgba(206, 17, 38, 0.4)';
          }
        }}
      >
        {loggingIn && (
          <div style={styles.loadingSpinner} className="loading-spinner"></div>
        )}
        {loggingIn ? 'Signing In...' : 'Sign In'}
      </button>

      {/* Forgot Password Link */}
      <div style={{
        textAlign: 'center',
        marginTop: '16px'
      }}>
        <a 
          href="/forgot-password"
          style={{
            color: '#CE1126',
            textDecoration: 'none',
            fontSize: '14px',
            fontWeight: 500,
            transition: 'all 0.2s ease'
          }}
          onMouseEnter={(e) => {
            e.target.style.textDecoration = 'underline';
            e.target.style.color = '#A00E1E';
          }}
          onMouseLeave={(e) => {
            e.target.style.textDecoration = 'none';
            e.target.style.color = '#CE1126';
          }}
        >
          Forgot Password?
        </a>
      </div>
    </form>
  );
};

export default LoginForm;